export const GET_ALL_LEAVE_APPLICATION = "GET_ALL_LEAVE_APPLICATION";
export const GET_ALL_TEACHER_LEAVE = "GET_ALL_TEACHER_LEAVE";

